export type SaladSaucePreferenceValue =
  | 'both_on_top'
  | 'salad_only'
  | 'sauces_only'
  | 'salad_separate'
  | 'sauces_separate';

export const DEFAULT_SALAD_SAUCE_PREFERENCE: SaladSaucePreferenceValue = 'both_on_top';

export const SALAD_SAUCE_PREFERENCES: Array<{ value: SaladSaucePreferenceValue; label: string }> = [
  { value: 'both_on_top', label: 'Salad and Sauces on top' },
  { value: 'salad_only', label: 'Salad Only' },
  { value: 'sauces_only', label: 'Sauces Only' },
  { value: 'salad_separate', label: 'Salad Separate' },
  { value: 'sauces_separate', label: 'Sauces Separate' },
];

export function isSaladSaucePreferenceValue(value: string): value is SaladSaucePreferenceValue {
  return SALAD_SAUCE_PREFERENCES.some((option) => option.value === value);
}

export function saladSaucePreferenceLabel(value: SaladSaucePreferenceValue): string {
  return SALAD_SAUCE_PREFERENCES.find((option) => option.value === value)?.label ?? value;
}
